let arrayData = [
  {
    key: 1,
    contrato: "contrato 1",
    condiciones: "condicion 1",
    abogado: "A1",
    municipio: "Municipio",
  },
  {
    key: 2,
    contrato: "contrato 2",
    condiciones: "condicion 2",
    abogado: "A2",
    municipio: "Municipio",
  },
  {
    key: 3,
    contrato: "contrato 3",
    condiciones: "condicion 3",
    abogado: "A3",
    municipio: "Municipio",
  },
  {
    key: 4,
    contrato: "contrato 4",
    condiciones: "condicion 4",
    abogado: "A4",
    municipio: "Municipio",
  },
  {
    key: 5,
    contrato: "contrato 5",
    condiciones: "condicion 5",
    abogado: "A5",
    municipio: "Municipio",
  },
];

const getCondLegales = async () => {
  return [];
};

const getCondLegal = (id) => {
  const CondLegal = arrayData.find((e) => +e.key === +id);

  return CondLegal;
};

const editCondLegal = (id, newData) => {
  let result = arrayData.map((e) => { return (e.key === id) ? newData : e; });

  return result;
};

const deleteCondLegal = (data) => {
  let result = arrayData.filter((e) => e.key !== data.key);

  return result;
};


export const condLegalesService = {
  getCondLegales,
  getCondLegal,
  editCondLegal,
  deleteCondLegal,
};
